import { FC, PropsWithChildren } from 'react'
import { cn } from '@wellesley/ui'

type GreyErrorBlockProps = PropsWithChildren & {
  className?: string
}
export const GreyErrorBlock: FC<GreyErrorBlockProps> = ({
  children,
  className,
}) => (
  <div
    className={cn(
      'mb-s rounded-xs bg-gray-50 p-xxxs text-center text-base text-gray-400 md:w-[450px]',
      className,
    )}
  >
    {children}
  </div>
)
